import { Navigate, Outlet, useLocation } from 'react-router';
import { useUser } from '@clerk/clerk-react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

/**
 * GuestGuard - PREVENTS AUTHENTICATED USERS FROM ACCESSING GUEST-ONLY ROUTES
 * REDIRECTS AUTHENTICATED USERS TO THEIR PREVIOUS LOCATION OR /DASHBOARD
 */

export function GuestGuard({
  children
}) {
  const { state } = useLocation();
  const { isLoaded, isSignedIn } = useUser();

  // Show spinner while Clerk is loading
  if (!isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const redirectPath = state?.from || '/dashboard';

  if (isSignedIn) {
    return <Navigate replace to={redirectPath} />;
  }

  return children || <Outlet />;
}